<template>
    <div class="OfficeAdd" v-if="lang">
        <div class="header header-mobile">
            <aside class="step">
                <div class="circle active">&nbsp;</div>
                <span class="active">{{ translate.pages.extrahours.add.tabs.address.title }}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div class="circle" :class="{ active: steps.two.active || steps.three.active || steps.four.active }"></div>
                <span :class="{ active: steps.two.active || steps.three.active || steps.four.active }">{{ translate.pages.extrahours.add.tabs.start_date.title }}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div class="circle" :class="{ active: steps.three.active || steps.four.active }"></div>
                <span :class="{ active: steps.three.active || steps.four.active }">{{ translate.pages.extrahours.add.tabs.end_date.title }}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div class="circle" :class="{ active: steps.four.active }"></div>
                <span :class="{ active: steps.four.active }">{{ translate.pages.extrahours.add.tabs.reason.title }}</span>
            </aside>
        </div>
        <br>
        <div class="content">
            <div v-if="steps.one.active">
                <header class="content-header">
                    <h3>{{ translate.pages.extrahours.add.tabs.address.subtitle }}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex="100" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.office.invalid }">
                                <label>{{ translate.pages.extrahours.add.fields.office }}</label>
                                <md-select name="office" id="office" v-model="data.office">
                                    <md-option v-for="office in offices" :value="office.id" :key="office.id">{{ office.name }}</md-option>
                                </md-select>
                                <span class="md-error" v-if="errors.office.invalid">{{ errors.office.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <div v-else-if="steps.two.active">
                <header class="content-header">
                    <h3>{{ translate.pages.extrahours.add.tabs.start_date.subtitle }}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                            <label>{{ translate.pages.extrahours.add.fields.start_date }}</label>
                            <md-icon class="icon-calendar">today</md-icon>
                            <date-picker :option="option" :limit="limit" class="picker" :date="startDate" v-model="data.start_date"></date-picker>
                            <small class="small-error" v-if="errors.start_date.invalid">{{ errors.start_date.msg }}</small>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                            <label>{{ translate.pages.extrahours.add.fields.start_time }}</label>
                            <md-icon>query_builder</md-icon>
                            <vue-timepicker class="timer" v-model="data.start_time_value" format="HH:mm" @change="updateTime($event, 'start_time')"></vue-timepicker>
                            <span class="span-error">{{ errors.start_time.msg }}</span>
                        </md-layout>
                        <md-layout md-flex="100" class="container">
                            <md-checkbox md-theme="green" class="checkbox-list md-primary" id="interval" name="interval" v-model="data.interval">
                                <strong>{{ translate.pages.extrahours.add.fields.extrahour_in_intervals }}</strong>
                                <span class="color_form_placeholder normal">&nbsp;&nbsp;&nbsp; {{ translate.pages.extrahours.add.fields.extrahour_in_intervals_description }}</span>
                            </md-checkbox>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <div v-else-if="steps.three.active">
                <header class="content-header">
                    <h3>{{ translate.pages.extrahours.add.tabs.end_date.subtitle }}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                            <label>{{ translate.pages.extrahours.add.fields.end_date }}</label>
                            <md-icon class="icon-calendar">today</md-icon>
                            <date-picker :option="option" :limit="limit" class="picker" :date="endDate" v-model="data.end_date"></date-picker>
                            <small class="small-error" v-if="errors.end_date.invalid">{{ errors.end_date.msg }}</small>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                            <label>{{ translate.pages.extrahours.add.fields.end_time }}</label>
                            <md-icon>query_builder</md-icon>
                            <vue-timepicker class="timer" v-model="data.end_time_value" format="HH:mm" @change="updateTime($event, 'end_time')"></vue-timepicker>
                            <span class="span-error">{{ errors.end_time.msg }}</span>
                        </md-layout>
                        <md-layout md-flex="100" class="container checkbox-list">
                            <md-checkbox md-theme="green" class="md-primary" id="interval" name="interval" v-model="data.interval">
                                <strong>{{ translate.pages.extrahours.add.fields.extrahour_in_intervals }}</strong>
                                <span class="color_form_placeholder normal">&nbsp;&nbsp;&nbsp; {{ translate.pages.extrahours.add.fields.extrahour_in_intervals_description }}</span>
                            </md-checkbox>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <div v-else>
                <header class="content-header">
                    <h3>{{ translate.pages.extrahours.add.tabs.reason.subtitle }}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex="100" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.reason.invalid }">
                                <label>{{ translate.pages.extrahours.add.fields.reason }}</label>
                                <md-input type="text" v-model="data.reason" required></md-input>
                                <span class="md-error" v-if="errors.reason.invalid">{{ errors.reason.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <footer class="content-footer">
                <hr>
                <div class="buttons clearfix">
                    <div class="return">
                        <md-button class="md-raised md-size btn--gray" :disabled="steps.button" @click.native="previous"><md-icon>keyboard_arrow_left</md-icon> {{ translate.pages.extrahours.add.buttons.previous }}</md-button>
                    </div>
                    <div class="next">
                        <md-button class="md-raised md-primary md-size btn--blue" @click.native="next" :disabled="process">{{ translate.pages.extrahours.add.buttons.next }} <md-icon>keyboard_arrow_right</md-icon></md-button>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>
<script>
    import { doctor } from '../../../config/api.js';
    const swal = require('sweetalert2');
    import moment from 'moment';
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import { datepicker, options } from '../../../config/datepicker.js';
    import VueTimepicker from 'vue2-timepicker';
    export default {
        data() {
            return {
                startDate: { time: datepicker.now_format},
                endDate: { time: datepicker.now_format},
                option: options,
                limit: [
                    {
                        type: 'fromto',
                        from: moment().subtract(1, "days"),
                        to: ''
                    }
                ],
                steps: {
                    'one': {
                        active: true,
                        valid: false
                    },
                    'two': {
                        active: false,
                        valid: false
                    },
                    'three': {
                        active: false,
                        valid: false
                    },
                    'four': {
                        active: false,
                        valid: false
                    },
                    'current': 'one',
                    'button': true
                },
                data: {
                    'office': '',
                    'start_date': '',
                    'start_time': '',
                    'start_time_value': {
                        HH: '',
                        mm: ''
                    },
                    'end_date': '',
                    'end_time': '',
                    'end_time_value': {
                        HH: '',
                        mm: ''
                    },
                    'reason': '',
                    'interval': true,
                },
                offices: [],
                process: false,
                disabled: true,
                errors: {
                    'office': {
                        'invalid': false,
                        'msg': ''
                    },
                    'start_date': {
                        'invalid': false,
                        'msg': ''
                    },
                    'start_time': {
                        'invalid': false,
                        'msg': ''
                    },
                    'end_date': {
                        'invalid': false,
                        'msg': ''
                    },
                    'end_time': {
                        'invalid': false,
                        'msg': ''
                    },
                    'reason': {
                        'invalid': false,
                        'msg': ''
                    },
                    'response': {
                        'invalid': false,
                        'msg': ''
                    }
                },
            }
        },
        created() {
            let url = doctor.api.offices;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get offices
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.offices = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        computed: {
            // Get language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Validate step form
            next() {
                let error = false;
                if(this.steps.current == 'one')
                {
                    // validate one
                    if(this.data.office.length == 0)
                    {
                        this.errors.office.invalid = true;
                        this.errors.office.msg = this.translate.pages.extrahours.add.validations.proximate.office;
                        error = true;
                    }else{
                        this.errors.office.invalid = false;
                        this.errors.office.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.steps.one.active = false;
                        this.steps.one.valid = true;
                        this.steps.two.active = true;
                        this.steps.button = false;
                        this.steps.current = "two";
                    }
                }else if(this.steps.current == 'two'){
                    this.data.start_date = this.startDate.time;
                    // validate two
                    if(this.data.start_date.length == 0)
                    {
                        this.errors.start_date.invalid = true;
                        this.errors.start_date.msg = this.translate.pages.extrahours.add.validations.proximate.start_date;
                        error = true;
                    }else{
                        this.errors.start_date.invalid = false;
                        this.errors.start_date.msg = "";
                    }
                    if(this.data.start_time.length < 5)
                    {
                        this.errors.start_time.invalid = true;
                        this.errors.start_time.msg = this.translate.pages.extrahours.add.validations.proximate.start_time;
                        error = true;
                    }else{
                        this.errors.start_time.invalid = false;
                        this.errors.start_time.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.steps.two.active = false;
                        this.steps.two.valid = true;
                        this.steps.three.active = true;
                        this.steps.button = false;
                        this.steps.current = "three";
                    }
                }else if(this.steps.current == 'three'){
                    this.data.end_date = this.endDate.time;
                    // validate three
                    if(this.data.end_date.length == 0)
                    {
                        this.errors.end_date.invalid = true;
                        this.errors.end_date.msg = this.translate.pages.extrahours.add.validations.proximate.end_date;
                        error = true;
                    }else{
                        this.errors.end_date.invalid = false;
                        this.errors.end_date.msg = "";
                    }
                    if(this.data.end_time.length < 5)
                    {
                        this.errors.end_time.invalid = true;
                        this.errors.end_time.msg = this.translate.pages.extrahours.add.validations.proximate.end_time;
                        error = true;
                    }else{
                        this.errors.end_time.invalid = false;
                        this.errors.end_time.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.steps.three.active = false;
                        this.steps.three.valid = true;
                        this.steps.four.active = true;
                        this.steps.button = false;
                        this.steps.current = "four";
                    }
                }else{
                    if(this.data.reason.length == 0)
                    {
                        this.errors.reason.invalid = true;
                        this.errors.reason.msg = this.translate.pages.extrahours.add.validations.proximate.reason;
                        error = true;
                    }else{
                        this.errors.reason.invalid = false;
                        this.errors.reason.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.process = true;
                        let url = doctor.api.extraHours;
                        let parent = this.$auth.getParent();
                        if(parent)
                        {
                            url += '?parent=' + parent;
                        }
                        this.$http.post(url, this.data, {
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                this.process = false;
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.$router.push({'name': 'ExtraHours'});
                                    }, (dismiss) => {
                                        console.log(dismiss);
                                        this.$router.push({'name': 'ExtraHours'});
                                    });
                            }).catch(error => {
                                this.process = false;
                                if(error.response.status === 422){
                                    let data = error.response.data;
                                    for(let index in data)
                                    {
                                        this.errors[index].invalid = true;
                                        let messages = '';
                                        data[index].forEach( item => messages += item + ' ');
                                        this.errors[index].msg = messages;
                                    }
                                    this.errors.response.invalid = false;
                                }else if(error.response.status === 404){
                                    this.errors.response.invalid = true;
                                    this.errors.response.msg = error.response.data.message;
                                }
                            });
                    }
                }
            },
            // Validate step form
            previous() {
                if(this.steps.current == 'two'){
                    this.steps.two.active = false;
                    this.steps.one.active = true;
                    this.steps.button = true;
                    this.steps.current = 'one';
                }else if(this.steps.current == 'three'){
                    this.steps.three.active = false;
                    this.steps.two.active = true;
                    this.steps.button = false;
                    this.steps.current = 'two';
                }else if(this.steps.current == 'four'){
                    this.steps.four.active = false;
                    this.steps.three.active = true;
                    this.steps.button = false;
                    this.steps.current = 'three';
                }
            },
            // Update time
            updateTime($event, target){
                this.data[target] = $event.data.HH + ':' + $event.data.mm;
            }
        },
        components: {
            'date-picker': myDatepicker,
            VueTimepicker
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    .OfficeAdd
        padding 3em 2.5em
        .header
            border 1px solid color_form_border
            border-radius 5px
            display flex
            font-size .9em
            font-weight bold
            justify-content space-around
            padding 1em 2em
            .step
                display flex
                cursor pointer
                .circle
                    border 1px solid color_form_border
                    border-radius 50%
                    height 18px
                    margin-right .5em
                    width 18px
                    &.active
                        background color_confirm
                        border-color color_confirm
                .active
                    color color_confirm
            .navigation
                height 2px
                background color_form_border
                min-width 10% !important
                margin-top .75em
        .content
            border 1px solid color_form_border
            border-radius 5px
            padding 1em 2em
            .h10
                height 10%
            .error
                color color_error
            &-header
                h3
                    margin-bottom 1em
            &-main
                .container
                    padding 0.25em 1em
                    .multiple
                        border 1px solid color_form_border
                        border-radius 5px
                        width 100%
                        .title
                            margin 0.5em
                            color color_form_placeholder
                        .select
                            overflow-y scroll
                            overflow-x hidden
                            margin 0.25em
                            height 110px
                            .option
                                width 95%
                                margin 0.25em
                    .subtitle
                        margin-top .5em
                        color color_form_placeholder
                    .w100
                        width 100%
                    .w90
                        width 90%
                    .w10
                        width 10%
                        margin-top 0
                    .span-error
                        color #ff5722
            &-footer
                margin-top 2em
                hr
                    background color_form_border
                    margin-bottom 1em
                    opacity 0.5
                min-height 5em
                .return
                    float left
                .next
                    float right
                    button
                        background color_main !important
                        color white
    .color_form_placeholder
        color color_form_placeholder
</style>


// WEBPACK FOOTER //
// Add.vue?00b600df